import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import axios from 'axios';
import _ from 'lodash';

// Query
import query from '../../../../queries/fetchFieldCollectionById';

// Components
import SingleMultipleAnswer from './SingleMultipleAnswer';
//import OpenAnswer from './OpenAnswer';
import MixedAnswer from './MixedAnswer';

class EditFieldCollection extends Component {
	constructor(props) {
		super(props);
		this.state = { _hydrated: false };
		this.handleOnChange = this.handleOnChange.bind(this);
		this.handleOnSubmit = this.handleOnSubmit.bind(this);
		this.parentStateCallback = this.parentStateCallback.bind(this);
	}
	static getDerivedStateFromProps(nextProps, prevState) {
		// Hydrate state with server data only once to avoid clobbering local edits
		if (!prevState._hydrated && nextProps.data && nextProps.data.fieldCollection) {
			return { ...nextProps.data.fieldCollection, _hydrated: true };
		}
		return null;
	}
	parentStateCallback(obj, type = 'default', position) {
		this.setState(prevState => {
			const { answers } = prevState;
			const newState = _.map(answers, (answer, i) => {
				if (i === Number(position)) {
					return { ...answer, ...obj };
				}
				return answer;
			});
			return {
				answers: newState
			};
		});
	}
	handleOnChange(e) {
		const { name, value } = e.target;
		this.setState({
			[name]: value
		});
	}
	handleOnSubmit(e) {
		const payload = this.state;
		axios
			.post('/survey/edit/fields', payload)
			.then(response => {
				this.props.history.goBack();
			})
			.catch(error => {
				console.log(error);
			});
	}
	renderAnswer() {
		const { type, answers } = this.state;
		if (type === 'single-choice' || type === 'multiple-choice') {
			return _.map(answers, (answer, i) => {
				const { label, value } = answer;
				return (
					<React.Fragment key={i}>
						<SingleMultipleAnswer
							key={i}
							parentStateCallback={this.parentStateCallback}
							initialValues={{ label, value }}
							position={i}
						/>
						<hr />
					</React.Fragment>
				);
			});
		} else if (type === 'mixed-question') {
			return _.map(answers, (answer, i) => {
				const { label, value, config } = answer;
				return (
					<React.Fragment key={i}>
						<MixedAnswer
							key={i}
							parentStateCallback={this.parentStateCallback}
							initialValues={{ label, value, config }}
							position={i}
						/>
						<hr />
					</React.Fragment>
				);
			});
		}
		//else if (type === 'open-question') {
		// 	return null;
		// }
		return null;
	}
	render() {
		return (
			<div className="container">
				<div className="row">
					<div className="col-sm-9">
						<div className="form-group">
							<label>Pregunta</label>
							<textarea
								name="question"
								value={this.state.question || ''}
								onChange={this.handleOnChange}
								className="form-control form-control-lg"
							/>
						</div>
					</div>
					<div className="col-sm-3">
						<div className="form-group">
							<label>Identificador</label>
							<input
								type="text"
								name="inputName"
								value={this.state.inputName || ''}
								onChange={this.handleOnChange}
								className="form-control"
							/>
							<small className="form-text text-muted">
								Etiqueta para identificar esta pregunta. No utilice espacios o
								caracteres especiales.
							</small>
						</div>
					</div>
				</div>
				<div className="render-answers">{this.renderAnswer()}</div>
				<button
					type="button"
					className="btn btn-primary"
					onClick={() => this.handleOnSubmit()}
				>
					Guardar
				</button>
			</div>
		);
	}
}

export default graphql(query, {
	options: props => {
		return { variables: { id: props.match.params.id } };
	}
})(EditFieldCollection);



// WEBPACK FOOTER //
// ./src/components/Survey/admin/EditFieldCollection/index.js